enum AnalyticsEvents {
  Page = 'Page',
  Clicks = 'Clicks',
}

export default AnalyticsEvents
